import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import TenantModal from './TenantModal';
import { useParams, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { useAuth } from '../../context/AuthContext';
import withPermission from '../../utils/withPermission';
import Swal from 'sweetalert2';
import TenantDetail from './TenantDetails';
import { Dropdown } from 'react-bootstrap';

const TenantList = ({ instanceId, onModalStateChange, onViewDetails, onShowModal }) => {
    const [tenants, setTenants] = useState([]);
    const [instances, setInstances] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedTenantId, setSelectedTenantId] = useState(null);
    const [selectedTenantData, setSelectedTenantData] = useState(null);
    const [errors, setErrors] = useState({});
    const didFetchRef = useRef(false);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const { id } = useParams();
    const [industries, setIndustries] = useState([]);
    const { roles, permissions } = useAuth();
    const WithDeletePermission = withPermission(({ children }) => children, ['tenant-delete']);
    const WithEditPermission = withPermission(({ children }) => children, ['tenant-edit']);
    const WithCreatePermission = withPermission(({ children }) => children, ['tenant-create']);
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    useEffect(() => {
        if (!didFetchRef.current) {

            // fetchIndustries();
            didFetchRef.current = true;
        }
    }, [currentPage]);

    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchTenants(1, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery]);
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };
    const fetchTenants = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/tenants?instance_id=${instanceId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: {
                    page,
                    search: searchQuery,
                },
                skipLoader:true,
            });

            const tenantData = response.data.Data.map(tenant => ({
                ...tenant,
                setup_name: tenant.instance ? tenant.instance.setup_name : 'Unknown',
                instanceId: tenant.instanceId || null,
            }));

            setTenants(tenantData);
            const totalPages = response.data.meta ? response.data.meta.total_pages : 1;
            setPageCount(totalPages);
            setCurrentPage(page);
        } catch (error) {
            console.error('Error fetching tenants:', error);
        }
    };

    const fetchIndustries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let allIndustries = [];



            const response = await axios.get(`${backendUrl}/api/industries`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });

            allIndustries = [...allIndustries, ...response.data.industry];


            setIndustries(allIndustries);
        } catch (error) {
            console.error('Error fetching industries:', error);
        }
    };
    const addTenant = async (newTenant) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/tenants?instance_id=${instanceId}`, newTenant, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const createdTenant = response.data?.Data[0];

            if (createdTenant) {
                createdTenant.setup_name = createdTenant.instance.setup_name;

                setTenants((prevTenants) => [...prevTenants, createdTenant]);
            } else {
                console.error('Creation failed, no data returned.');
            }

            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data?.errors; // Return validation errors
            } else {
                console.error('Error adding tenant:', error);
            }
        }
    };

    const editTenant = async (tenantId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.put(`${backendUrl}/api/tenants/${tenantId}`, updatedData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const updatedTenant = response.data?.Data;

            if (updatedTenant) {
                updatedTenant.setup_name = updatedTenant.instance.setup_name;

                setTenants((prevTenants) =>
                    prevTenants.map((tenant) =>
                        tenant.id === updatedTenant.id ? updatedTenant : tenant
                    )
                );
            } else {
                console.error('Update failed, no data returned.');
            }

            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response?.data?.errors; // Return validation errors
            } else {
                console.error('Error updating tenant:', error);
            }
        }
    };




    const deleteTenant = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;

                    await axios.delete(`${backendUrl}/api/tenants/${id}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });

                    setTenants(tenants.filter(tenant => tenant.id !== id));

                    Swal.fire(
                        "Deleted!",
                        "The tenant has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting tenant:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete tenant. Please try again.",
                        "error"
                    );
                }
            }
        });

    };
    const handleShowModal = (tenantId = null) => {
        if (onShowModal) {
            const tenantToEdit = tenantId ? tenants.find(tenant => tenant.id === tenantId) : null;
            onShowModal(tenantId, tenantToEdit);
        } else {
            if (tenantId) {
                const tenantToEdit = tenants.find(tenant => tenant.id === tenantId);
                setSelectedTenantData(tenantToEdit || null); // Set data for editing
            } else {
                setSelectedTenantData(null); // Clear form data for creating new tenant
                setErrors({}); // Clear any errors
            }
            setSelectedTenantId(tenantId);
            setShowModal(true);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedTenantId(null);
        setSelectedTenantData(null);
        setErrors({});
    };

    const [showTenantDetail, setShowTenantDetail] = useState(false);

    useEffect(() => {
        onModalStateChange?.(showModal || showTenantDetail);
    }, [showModal, showTenantDetail, onModalStateChange]);

    const handleShowTenantDetail = (id) => {
        if (onViewDetails) {
            onViewDetails(id);
        } else {
            setSelectedTenantId(id);
            setShowTenantDetail(true);
        }
    };

    const handleCloseTenantDetail = () => {
        setShowTenantDetail(false);
        setTimeout(() => setSelectedTenantId(null), 300); // Clear after animation
    };

    const getAccountStatusBadge = (status) => {
        switch (status) {
            case 'active':
                return <span className="badge badge-pill badge-soft-success font-size-12 text-success">Active</span>;
            case 'deactivated':
                return <span className="badge badge-pill badge-soft-warning font-size-12 text-warning">Deactivated</span>;
            case 'suspended':
                return <span className="badge badge-pill badge-soft-danger font-size-12 text-danger">Suspended</span>;
            default:
                return <span className="badge badge-pill badge-soft-secondary font-size-12">Unknown</span>;
        }
    };
    const handlePageChange = ({ selected }) => {
        const newPage = selected + 1;
        setCurrentPage(newPage);
        fetchTenants(newPage);
    };
    return (

        <React.Fragment>

            <h4 className="mb-sm-0 font-size-18"></h4>
            <div className="d-flex justify-content-end mb-2">
                {/* Search Box */}
                <div className="search-box me-2">
                    <div className="position-relative">
                        <input
                            type="text"
                            className="form-control font-size-12 "
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                        />
                        <i className="bx bx-search-alt search-icon" />
                    </div>
                </div>

                {/* Add Tenant Button */}
                <WithCreatePermission>
                    <button
                        type="button"
                        className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                        onClick={() => handleShowModal()}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        id="tool"
                        title="Add Tenant"
                    >
                        <i className="mdi mdi-plus" style={{ fontSize: "16px" }}></i>
                    </button>
                </WithCreatePermission>
            </div><br />


            <div className="contacts-table-modern">
                <div className="table-responsive" style={{ overflow: 'visible', minHeight: '200px', paddingBottom: '100px' }}>
                    <table className="table table-modern">
                        <thead>

                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Name</th>
                                <th scope="col">Tenant Id</th>
                                <th scope="col">Account Status</th>
                                {/* <th>Status Note</th> */}
                                {/* <th>Login</th> */}
                                <th scope="col">IP Check</th>
                                {/* <th>IPs</th> */}
                                <th scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tenants.length > 0 ? (
                                tenants.map((tenant, index) => (
                                    <tr key={tenant.id}>
                                        <td>{index + 1}</td>
                                        <td><button onClick={() => handleShowTenantDetail(tenant.id)} className="dropdown-item fw-bold text-black">
                                            {tenant.name}</button></td>
                                        <td>
                                            <button onClick={() => handleShowTenantDetail(tenant.id)} className="dropdown-item text-black">
                                                {tenant.tenant_info_id}</button>
                                        </td>
                                        <td>{getAccountStatusBadge(tenant.account_status)}</td>
                                        {/* <td>{tenant.status_note}</td> */}
                                        {/* <td>{tenant.login}</td> */}
                                        <td>{tenant.ip_check ? 'True' : 'False'}</td>
                                        {/* <td>{tenant.ips}</td> */}
                                        <td>
                                            <Dropdown drop="start" align="end">
                                                <Dropdown.Toggle as="div" className="text-muted" style={{ cursor: 'pointer' }}>
                                                    <i className="mdi mdi-dots-horizontal font-size-18"></i>
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className="dropdown-menu-end font-size-14">
                                                    <Dropdown.Item onClick={() => handleShowTenantDetail(tenant.id)}>
                                                        View Details
                                                    </Dropdown.Item>
                                                    
                                                    <WithEditPermission>
                                                        <Dropdown.Item onClick={() => handleShowModal(tenant.id)}>
                                                            Edit
                                                        </Dropdown.Item>
                                                    </WithEditPermission>

                                                    <WithDeletePermission>
                                                        <Dropdown.Item onClick={() => deleteTenant(tenant.id)} className="text-danger">
                                                            Delete
                                                        </Dropdown.Item>
                                                    </WithDeletePermission>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8">No tenants available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="d-flex justify-content-end pagination-sm">
                <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={handlePageChange}
                    containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                    pageClassName={'page-item'}
                    pageLinkClassName={'page-link'}
                    previousClassName={'page-item previous'}
                    previousLinkClassName={'page-link'}
                    nextClassName={'page-item next'}
                    nextLinkClassName={'page-link'}
                    breakClassName={'page-item'}
                    breakLinkClassName={'page-link'}
                    activeClassName={'active'}
                />
            </div>


            {!onShowModal && (
                <TenantModal
                    showModal={showModal}
                    handleClose={handleCloseModal}
                    tenantId={selectedTenantId}
                    tenantData={selectedTenantData}
                    addTenant={addTenant}
                    editTenant={editTenant}
                    instanceId={id}
                    errors={errors}
                    setErrors={setErrors}
                    industries={industries}
                    tenants={tenants}
                    fetchIndustries={fetchIndustries}
                />
            )}

            {!onViewDetails && (
                <TenantDetail 
                    show={showTenantDetail} 
                    onHide={handleCloseTenantDetail} 
                    tenantId={selectedTenantId}
                />
            )}
        </React.Fragment>


    );
};
export default TenantList;








